import { rhythm } from 'Themes/typography';
import styled from 'styled-components';

const Container = styled.div`
  padding: ${rhythm(0.5)} 4.16667vw ${rhythm(2)};
  flex: 1;
  position: relative;
  max-width: 1024px;
`;

export default Container;
